export const m = {
    location:"当前位置",
    logout:'退出',
    alert: {
        reminder: '提示',
        confirm: '确定',
        cancel: '取消',
        changeTip: '确定修改？',
        deleteConfirm: '是否确定删除？',
        changeConfirm: '是否确定修改？',
        addConfirm: '是否确定添加？',
        saveConfirm: '是否确定保存？',
        handle: '是否确定操作？',
        logout: '确定退出当前账户?',
        updateUser: '确定要更新用户信息?',
        submit: '确定要提交吗？',
        error:'操作失败',
        success: '操作成功',
        addSuccess: '创建成功',
        addError: '创建失败',
        saveSuccess: '保存成功',
        saveError: '保存失败',
        changeSuccess: '修改成功',
        changeError: '修改失败',
        deleteSuccess: '删除成功',
        deleteError: '删除失败',
        updateSuccess: '更新成功',
        updateError: '更新失败',
        codeSuccess: '验证码发送成功',
        codeResetSuccess: '密码重置成功，请登录',
        tip1: '与该设备相关的所有内容将会被删除，确认是否进行解绑操作?',
        canceled: '取消操作',
        cancelDelete: '已取消删除',
        phoneError: '手机号格式错误'
    },
    index:{
        index:'首页',
        userManage:'用户管理',
        device:{
            title:'设备',
            bindDevice:'设备列表',
            deviceList:'所有用户设备',
        },
        chart:{
            title:'曲线',
            myChart:'曲线列表',
            recommendChart:'推荐曲线',
            collChart:'收藏曲线',
            userChart: '所有用户曲线',
            ourChart: '我的曲线',
            clear:'清空',
            all: "全部曲线"
        },
        bean:{
            title:'仓储',
            myBean:'用户仓储',
            factoryRecommend:'工厂推荐',
            userBean:'所有用户仓储',
        },
        cup:{
            title:'杯测',
            myCupEvaluate:'杯测列表',
            userCupEvaluate:'所有用户杯测'
        },
        setting:{
            title:'设置',
            accountManage:'账户管理',
            quickEventManage:'快速事件管理',
            systemSetting:'系统设置',
            userGuide:'用户手册',
            about:'关于 HB',
            userManage:'用户管理',
            settingDeviceType: '设备类型',
            company: '公司',
            address: '地址',
            all: '所有',
            user: '用户名',
            userDetail: '用户详情',
            tempUnit: '温度单位',
            weightUnit:'重量单位',
        }

    },
    common: {
        reset: "重置"
    },
    login:{
        sysName: '后台管理系统',
        rememberMe:'记住我',
        login:'登录',
        placeholder:{
            userName:'请输入用户名',
            password: '请输入密码',
            password2:'确认密码',
            phone:'请输入手机号',
            email:'请输入邮箱',
            code:'请输入验证码',
        },
        forgetPassword:'忘记密码',
        register:'注册',
        tabPwd:'用户名登录',
        tabCode:'手机号登录',
        phoneValid:'手机号验证',
        emailValid:'邮箱验证',
        tabEmailCode:'邮箱登录',
        getCode:'获取验证码',
        getEmailCode:'获取验证码',
        licence: '用户协议',
        phoneError: '手机号格式错误',
        emailError:'电子邮箱格式错误'
    },
    deviceIndex: {
        reportUpload:'报告机器上传',
        deviceTypeDetail:'设备类型详情',
        deviceList: '设备列表',
        deviceInfo: '设备信息',
        selectedDevice: '当前设备',
        deviceState: '设备状态',
        beanTemper: '豆温',
        inletAirTemperature: '热风温',
        environmentTemper: '环境温',
        outWindTemper: '排风温',
        beanInfo: '生豆信息',
        beanKind: '生豆种类',
        beanWeight: '生豆库存',
        loadNewMessage: '加载新消息',
        MaintainNewMsg: "维保新消息",
        maintainHistoryMsg: '维保历史消息',
        heating: '火力',
        airflow: '热风',
        drum: '滚筒',
        cooling:'冷却',
        table:{
            createTime:'创建时间',
            content:'内容',
            operation:'操作'
        }
    },
    userList:{
        userList:'用户列表',
        userTable:{
            avatar:'头像',
            username:'用户名',
            phone:'手机',
            email:'邮箱',
            operation:'操作',
            createtime:'注册时间'
        },
        tabs:{
            beanList:'生豆列表',
            deviceList:'设备列表',
            reportList:'曲线列表',
            commentList:'杯测列表'
        },
        table:{

            bean:{
                name:'名字',
                stock:'库存',
                createTime:'创建时间',
                productArea:'产区',
                handleMethod:'处理方法',
                manor:'庄园',
                country:'国家',
                price:'价格',
                altitude:'海拔',
                waterPercent:'水含量',
                supplier:'供应商',
                level:'等级',
                kind:'种类',
                supplierContact:'供应商联系方式',
                buyLink:'购买链接',
                beanReport: '生豆曲线'
            },
            device:{
                name:'名字',
                deviceType:"设备类型",
                systemSeriesNum:'系统串号',
                createTime:'创建时间',
                deviceStatus:'设备状态',
                runTimeLog:'运行日志',
                maintainLog:'维保日志',
                bakeTime:'烘焙时间',
                runTime: '运行时间'
            },
            report:{
                name:'名字',
                reportColor:'烘焙度',
                reportLevel:'曲线等级',
                type:'曲线种类',
            },
            cupEvaluate:{
                cupEvaluate:'杯测',
                name:'名字',
                color:'烘焙度',
                feedback:'反馈',
                score:'总分',
                level:'等级',
                operation:'操作',
                look:'查看',
            }
        }
    },
    deviceManage:{
        bindDevice:{
            name:'名字',
            type:'设备型号',
            systemSeriesNum: '设备序列号',
            deviceSeriesNum: '设备编号',
            no:'编号',
            bindTime:'创建时间',
            createTime:'创建时间',
            deviceStatus:'设备状态',
            deviceLocation:'设备位置',
            bakeTime:'烘焙时长',
            runTimeLength:'运行时长',
            runTimeLog:'运行日志',
            maintainLog: '维保日志',
            notUpload: '未上传',
            curveList: '曲线列表',
            runLog: '运行日志',
            roastLog: '烘焙日志',
            maintenanceReminder: '维保提醒',
            addMaintenanceReminder: '新增维保提醒',
            editMaintenanceReminder: '编辑维保提醒',
            maintenanceHistory: '维保历史',
            addMaintenanceHistory: '新增维保历史',
            editMaintenanceHistory:'编辑维保历史',
            alarmLog: '报警日志',
            duration: '时长',
            date: '日期',
            timeHour:'时间(小时)',
            star: '星级',
            content: '内容',
            triggerCondition: '触发条件',
            tableType:'类型',
            count: "告警总数",
            operation: {
                name:'操作',
                detail:'详情',
                unbind:'解绑',
                addMaintain: '添加维保',
                edit: '编辑',
                delete:'删除'
            },
            button:{
                bindBtn:'绑定'
            },
            dialog:{
                return:'返回',
                bindDialog:{
                    seriesNumber:'设备编号',
                    placeholder: '请输入设备编号',
                    placeholder2:'请输入设备名称',
                    title:'绑定设备',
                    bindBtn:'绑定',
                    return: '返回',
                    cancel: '取消',
                    confirm: '确定'
                },
                runTimeDialog:{
                    title:'运行日志',
                    createTime:'创建时间',
                    runTime:'时长',
                    bakeTime:'烘焙时间',
                    index:'索引',
                    timeLength:'时长',
                    date:'上传时间',
                    all:'所有',
                    return:'返回'
                },
                maintainDialog:{
                    tabMaintainLog:{
                        title:'维保日志',
                        currentDevice:'当前设备',
                        deviceStatus:'设备状态',
                        index:'序号',
                        user:'人员',
                        items:'维保事项',
                        solution:'内容',
                        date:'时间',
                        detail:'详情',
                    },
                    tabMaintainNewMsg:{
                        title:'维保新消息',
                        date:'时间',
                        content:'内容',
                        loadBtn:'加载新消息',
                        loadNewMsg:'加载新消息'
                    },
                    historyTab:{
                        title:'历史维保消息',
                        deleteBatch:'批量删除',
                        date:'时间',
                        content:'内容',
                    }
                },
                maintainDetailDialog:{
                    title:'维保详情',
                    type:'类型',
                    user:'人员',
                    items:'维保事项',
                    solution:'解决方法',
                    return:'返回'
                },
                addMaintainDialog:{
                    title:'维保详情',
                    type:'类型',
                    user:'人员',
                    items:'维保事项',
                    solution:'解决方法',
                    return:'返回'
                },
                deviceDetailDialog:{
                    title:'设备详情',
                    name:'名字',
                    deviceModel:'设备型号',
                    systemSeriesNum:'系统串号',
                    bindTime:'绑定时间',
                    deviceStatus:'设备状态',
                    runTimeLength:'运行时长',
                    maintainLog:'维保日志',
                    deviceLocation:'设备位置',
                    bakeTime:'烘焙时间',
                    copy:'复制',
                }
            }
        },
        deviceList:{
            name:'名字',
            type:'型号',
            systemSeriesNum:'系统串号',
            bindTime:'绑定时间',
            createTime:'创建时间',
            deviceStatus:'设备状态',
            deviceLocation:'设备位置',
            runTimeLog:'运行日志',
            maintainLog:'维保日志',
            button:{
                all:'所有',
                search:'搜索',
                addDevice:'添加设备',
                ascending:'升序',
                descending:'降序',
            },
            options:{
                searchOptions:{
                    deviceName:'设备名称',
                    serialNumber:'序列号',
                    systemSeriesNum:'系统串号',
                },
                orderOptions:{
                    createTime:'创建时间',
                    deviceType:'设备型号',
                }

            },
            dialog:{
                bindDialog:{
                    seriesNumber:'序列号',
                    title:'绑定设备',
                    bindBtn:'绑定',
                    return: '返回',
                    cancel: '取消',
                    confirm: '确定'
                },
                runTimeDialog:{
                    runTime:'运行时间',
                    bakeTime:'烘焙时间',
                    index:'index',
                    timeLength:'时长',
                    date:'时间',
                    all:'综合',
                    return:'返回'
                },
                maintainDialog:{
                    tabMaintainLog:{
                        title:'维保日志',
                        currentDevice:'当前设备',
                        deviceStatus:'设备状态',
                        index:'index',
                        user:'人员',
                        items:'维保事项',
                        solution:'解决方法',
                        date:'时间',
                        detail:'详情',
                    },
                    tabMaintainNewMsg:{
                        title:'维保新消息',
                        date:'时间',
                        content:'内容',
                    },
                    historyTab:{
                        title:'历史消息',
                        deleteBatch:'批量删除',
                        date:'时间',
                        content:'内容',
                    }
                },
                maintainDetailDialog:{
                    title:'维保详情',
                    type:'类型',
                    user:'人员',
                    items:'维保事项',
                    solution:'解决办法',
                    return:'返回'
                }
            }
        },
        deviceDetial: {
            user: '用户',
            roastDate: '创建日期',
            addCollect: '添加收藏',
            cancelCollect: '取消收藏',
            addRecommend: '添加推荐',
            cancelRecommend: '取消推荐',
            coffeeBeans: '咖啡豆',
            cfName: '名称',
            cfLevel: '等级',
            cfOpreate: '处理',
            cfOpreate2: '处理方式',
            cfDate: '时间',
            cfWeight: '重量',
            cfAllWeight: '总重量',
            season: '产季',
            kind: '种类',
            kind2:'种'
        }
    },
    chart:{
        chart: '曲线',
        chartSelect:'曲线选择',
        chartList:'曲线列表',
        btn:{
            all:'所有',
            train:'训练',
            draw:'手绘',
            import: '导入',
            newImport:'导入',
            newDraw:'新增手绘'

        },
        table:{
            name:'名称',
            color:'烘焙度',
            level:'等级',
            kind:'类别',
            date:'日期',
            owner: '拥有者',
            duration: '时长',
            machineName: '设备',
            search: '搜索',
            cancel: '取消',
            confirm: '确定',
            placeholder1: '请输入报告名称',
            placeholder2: '请输入报告备注',
            placeholder3:'请输入搜索条件',
            label1: '报名名称',
            label2: '报名备注',
            curveImport: '曲线导入',
            back: '返回',
            select: '选取文件',
            uploadTip: '导入json格式文件，其他格式已屏蔽，不可选取',
            add: '添加',
            score: '分',
            username: "用户"
        },
        chartDetail:{
            title:'曲线详情',
            color:'烘焙度',
            reportName:'报告名字',
            level:'等级',
            type:'类别',
            temper:'预热温',
            reportKind:'报告类别',
            beanName:'生豆名称',
            beforeWeight:'生豆重量',
            afterWeight:'熟豆重量',
            unit: '温度单位',
            tabAllPoint:'所有点',
            beanTemperPoint:'事件列表',
            ror:'ror',
            environmentTemper:'环境温度',
            outWind:'出风温度曲线',
            inWind:'进风温度曲线',
            eventName:'事件名称',
            temperRate:'温度',
            temperRate1:'升温率',
            occurrenceTime:'发生时间'
        },
        wind:'风力',
        fire:'火力',
        speed:'速度',
        addChart:'添加曲线'
    },

    commentDetail: {
        title: '杯测详情',
        date:'时间',
        roast:'烘焙度',//烘焙度
        dryFragrant:'干香/湿香',//干香湿香
        flavor:'风味',//风味
        taste:'余韵',//圆味值
        acid:'酸度',//酸度
        mellow:'醇厚度',//醇厚度
        consistency:'一致性',//一致性
        balance:'平衡性',//平衡感
        clean:'干净度',//干净度
        sweetness:'甜度',//甜度
        overallEvaluation: '总体评价',//总体评价
        cupping: '杯测评分',
        defects: '烘焙瑕疵',
        finalScore: '最终得分',
        scoreStandard: '评分标准',
        saveChange: '保存修改',
        delete: '删除',
        remark: '备注',
        time: '日期',
        name: '名称',
        add: '添加',
        select: '选择曲线',
        dry: '干',
        break: '湿',
        inputDescription: '输入描述',
        submit: '提交',
        strength: '强度',
        high: '高',
        low: '低',
        degree: '程度',
        thin: '薄',
        heavy: '厚',
        development: '发展度',
        chocolate: '巧克力',
        candy: '糖果',
        orange:'甜橙',
        flavorDescription: '风味描述',
        description: '杯测总体描述',
        underdeveloped: '发展未成熟',
        overdeveloped: '过度发展',
        baked: '焙烤',
        faced: '表面烤焦',
        scoreDescription: '瑕疵打分说明',
        noEffect: '无觉瑕疵',
        aLittleBit: '一点点',
        palpable: '明显察觉',
        overwhelming: '压倒性',
        scoringInstructions: '杯测打分说明',
        good: '好',
        veryGood: '非常好',
        excellent: '出色',
        outstanding: '非凡',
        user:'用户'
    },
    cupEvaluate:{
        table:{
            choose:'选择',
            cupEvaluate: '杯测',
            name: '名称',
            owner: '测评者',
            color: '烘焙度',
            feedback: '反馈',
            score: '得分',
            level: '等级',
            operation: '操作',
            look: '详情',
            edit:'编辑',
        },
        cupList:'杯测列表',
        detailDialogTitle:'杯测详情',
        editDialogTitle:'编辑杯测',
    },
    bean:{
        table:{
            name: '名称',
            owner: '拥有者',
            stock: '重量',
            addTime: '添加时间',
            productArea: '产区',
            handleMethod: '处理',
            manor: '庄园',
            country: '国家',
            price: '价格',
            altitude: '海拔',
            unit:'米',
            waterPercent: '含水量',
            supplier: '供应商',
            level: '等级',
            kind: '豆种',
            supplierContact: '联系方式',
            buyLink: '购买链接',
            createTime:'创建时间',
            chanji:'产季'
        },
        beanDetailDialog:'生豆详情',
        addBeanBtn:'添加生豆',
        beanAllWeight:'生豆重量',
        beanKind:'生豆种类',
        beanUsedTop10:'生豆使用量排行',
        addRecommend:'添加推荐',
        cancelRecommend:'取消推荐'
    },
    accountManage: {
        phone:'手机',
        username:'用户名',
        email:'邮箱',
        oldPassword:'原密码',
        newPassword:'新密码',
        checkPassword:'确认密码',
    },
    quickEvent:{
        addEvent:'添加事件',
        eventName:'事件名字',
        source:'来源',
        describe:'描述',
        order:'排序',

    },
    systemSetting: {
        tab:{
            deviceTypeManage:'设备类型',
            maintenanceCycle:'维保周期',
            about:'关于 HB',
            unit:'温度单位',
        },
        deviceTypeName:'名字',
        productType:'产品类别',
        describe:'描述',
        userManual:'用户手册',
        upload:'上传',
        notUpload:'未上传',
        smallCycle:'小周期',
        bigCycle:'大周期',
        addDeviceType:'添加设备型号',


    },
    button: {
        all:'所有',
        deleteBatch: '批量删除',
        delete:'删除',
        return:'返回',
        search:'搜索',
        detail:'详情',
        save:'保存',
        edit:'编辑',
        add:'添加',
        look:'查看',
        unbind: '解绑',
        addMaintain: '添加维保',
        qrCode:'二维码',
        changePwd:'修改密码',
        cancel:'取消',
        export:'导出json',
        import:'导入',
        ascending:'升序',
        descending:'降序',
        addDevice: '添加设备',
        upload:'上传',
        lookCup:'查看杯测',
        lookChart:'曲线详情',
        deleteChart:'删除曲线',
        addPoint:'添加一点',
        clearAll:'清空',
        saveChart:'创建曲线',
        exportLog: '导出日志'
    },
    table:{
        time:'时间',
        operation:'操作',
        content: '内容',
        duration: '时长',
        starLevel: '星级',
        date: '日期',
        name: '名称',
        selectDate: '选择日期',
        select:'请选择'
    },
    options:{
        userSearchOptions: {
            name:'用户名',
            phone:'手机号',
            email:'邮箱'
        },
        beanManaSearchOptions: {
            keyword:'名称',
            kind:'种类',
            method:'处理方式'
        },
        beanManaOrderOptions:{
            stock:'库存'
        },
        deviceManaSearchOptions: {
            name:'名称',
            deviceType:'型号',
            serino:'序列号',
            status:'设备状态'
        },
        deviceManaOrderOptions:{
            bindTime:'绑定时间',
            runTime:'运行时间',
            hbTime:'烘焙时间'
        },
        reportManaSearchOptions: {
            name:'名称'
        },
        reportManaOrderOptions:{
            level:'等级',
            color:'烘焙度'
        },
        commentManaSearchOptions: {
            name:'名称'
        },
        commentManaOrderOptions:{
            score:'分数',
            level:'等级'
        },
        chartTypeOptions:{
            beanTemper:'豆表温度',
            inletAirTemperature: '热风温度',
            outWindTemper: '排风温度',
            environmentTemper: '环境温度',

        },
        deviceSearchOptions: {
            deviceName: '设备名称',
            deviceNumber:'设备型号',
            seriesNumber:'设备编号',
            systemSeriesNum:'设备序列号',
            status:'设备状态',
            deviceType: '设备类型',
            developmentTime: '发展时间',
            developmentRate: '发展率',
            RoR1: '回温至黄点温升',
            RoR2: '黄点至一爆温升',
            RoR3: '一爆至结束温升',
            roastDuration: '烘焙时长',// 	Roast duration
            start: '开始',// 	Start
            dropinTemp: '入豆温',// 	Drop-in temp
            turningPoint: '回温点',// 	Turning point
            yellowPoint: '转黄点',// 	Yellow point
            firstCrack: '一爆',// 	First crack
            secondCrack: '二爆',// 	Second crack
            end: '结束',// 	End
            process: '过程',// 	Process
            heat: '火力',// 	Heat
            airflow: '热风',// 	Airflow
            drum: '滚筒',// 	Drum
            heatAdjust: '调火力',// 	Heat adjust
            airflowAdjust: '调热风',// 	Airflow adjust
            drumAdjust: '调滚筒',// 	Drum adjust
            mark: '标记',// 	Mark
            exportPdf: '导出pdf',// 	Export pdf
            exprotJSON: '导出JSON',// 	Export JSON
            noData: '暂无数据',// 	No data
        },
        deviceOrderOptions:{
            createTime:'创建时间',
            deviceType:'设备型号',
            hbTime:'烘焙时间',
            runTime:'运行时间'
        },
        userChartSearchOptions:{
            reportName:'报告名称',
            reportLevel:'报告星级',
            reportColor:'报告颜色',

        },
        userChartOrderOptions:{
            reportOrderDate:'日期',
            reportOrderLevel:'等级',
        },
        beanSearchOptions:{
            name:'生豆名称',
            supply:'供应商'
        },
        beanOrderOptions:{
            firstName:'首字母',
            stock:'库存',
            createTime:'创建时间',
        },
        cupOrderOptions:{
            firstName:'首字母',
            score:'分数',
        },
        listTab: {
            time:'按时间',//	Time
            name: '按名称',//	Name
            machine: '按设备',
            star:'按星级',
            rating:'按评分',//	Rating
            create: '新建',//	create
            model: '按型号',
            inventory: '按库存',
            new: '新建',
            use:'按用量',
        }
    },
    placeholder:{
        date: '请输入日期',
        logout:'退出登录'
    },
    reportList:{
        top10:'使用排行前十'
    },
    protocol: `
        &nbsp;&nbsp;&nbsp;&nbsp;在您注册成为爱趣焙用户的过程中，您需要完成我们的注册流程并通过点击同意的形式在线签署以下协议，请您务必仔细阅读、充分理解协议中的条款内容后再点击同意。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;点击同意即表示您已阅读并同意《爱趣焙用户注册协议及软件许可使用协议》与《隐私政策》。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;（勾选之后注册按钮才会亮，才会允许注册，不勾选不允许注册）<br />
        &nbsp;&nbsp;&nbsp;&nbsp;用户注册协议及软件许可使用协议<br />  
        &nbsp;&nbsp;&nbsp;&nbsp;提示条款<br />  
        &nbsp;&nbsp;&nbsp;&nbsp;本软件许可使用协议（以下称“本协议”）由您与爱趣咖啡科技（宁波）有限公司（以下称“我们”）共同签署。在使用“爱趣焙”软件（以下称许可软件）之前，请您仔细阅读本协议，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体标识，您需要重点阅读。如您对本协议有任何疑问，可向客服咨询。如果您同意接受本协议条款和条件的约束，您可下载安装使用许可软件。由于互联网高速发展，您与我们签署的本协议列明的条款并不能完整罗列并覆盖您与我们所有的权利与义务，现在的约定也不能保证完全符合未来发展的需求。如您使用许可软件，视为您同意上述协议。我们如修改本协议或其补充协议，协议条款修改后，请您仔细阅读并接受修改后的协议后再继续使用许可软件。如果用户不接受修改后的条款请立即停止使用此软件和服务，用户继续使用此软件和服务视为已接受了修改后的协议。<br />     
        &nbsp;&nbsp;&nbsp;&nbsp;一.定义<br />     
        &nbsp;&nbsp;&nbsp;&nbsp; 1.1许可软件：是指由我们开发的，供您从下载平台下载，并仅限在相应系统手持移动端中安装、使用的软件系统，本软件及服务的所有权和运营权均归爱趣焙所有。<br />      
        &nbsp;&nbsp;&nbsp;&nbsp; 1.2服务：本软件为使用该移动智能终端的用户提供绑定、操作智能产品等服务。 <br />    
        &nbsp;&nbsp;&nbsp;&nbsp;二.软件授权及范围<br />     
        &nbsp;&nbsp;&nbsp;&nbsp;  2.1爱趣焙就本软件给予用户一项个人的、不可转让、不可转授权以及非独占性的许可。<br /> 
        &nbsp;&nbsp;&nbsp;&nbsp;  2.2用户可以为非商业目的在单一台移动终端设备上安装、使用、显示、运行本软件，用户不得为商业运营目的安装、使用、运行过程中释放任何到任何终端设备内存中的数据及本软件运行过程中客户端与服务器短的交互数据进行复制、更改、修改、挂接运行或创作任何衍生作品。<br /> 
        &nbsp;&nbsp;&nbsp;&nbsp;如果需要进行商业性的销售、复制和散发，例如软件预装和捆绑，必须获得爱趣焙的书面授权和许可。 <br /> 
        &nbsp;&nbsp;&nbsp;&nbsp;三.软件的获取、安装、升级<br />  
        &nbsp;&nbsp;&nbsp;&nbsp;  3.1用户应当按照爱趣焙的指定网站或指定方式下载安装本软件产品。谨防在非指定网站下载本软件，以免移动终端设备感染能破坏用户数据和获取用户隐私的恶意程序。如果用户从未经爱趣焙授权的第三方获取本软件或与本软件名称相同的安装程序，爱趣焙无法保证该软件能够正常使用，并对因此给您造成的损失不予负责。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;  3.2用户必须选择与所安装终端设备相匹配的本软件版本，否则，由于软件与设备型号不相匹配所导致的任何软件问题、设备问题或损害，均由用户自行承担。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;  3.3为了改善用户体验、完善服务内容，爱趣焙有权不时地为您提供本软件替换、修改、升级版本，也有权为替换、修改或升级收取费用，但收费提前得征得您的同意。本软件为用户默认开通“升级提示”功能，视用户使用的软件版本差异，爱趣焙提供给用户自行选择是否需要开通此功能。软件新版本发布后，爱趣焙不保证旧版本软件的继续可用。  <br />    
        &nbsp;&nbsp;&nbsp;&nbsp;四.使用规范<br />
        &nbsp;&nbsp;&nbsp;&nbsp;  4.1用户在遵守法律及本协议的前提下可依本协议使用本软件及服务，用户不得实施如下行为：<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.1.1 删除本软件及其他副本上一切关于版本的信息，以及修改、删除或避开本软件为保护知识产权而设置的技术措施；<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.1.2本软件禁止反向工程，如反汇编、反编译或者其他试图获得本软件的源代码；<br />  
        &nbsp;&nbsp;&nbsp;&nbsp;   4.1.3通过修改或伪造软件运行中的指令、数据、增加、删除、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；<br />   
        &nbsp;&nbsp;&nbsp;&nbsp;   4.1.4使用本软件进行任何危害网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/账户；未经允许进入公众网络或者他人操作系统并删除、修改、增加存储信息；未经许可企图探查、扫描、测试本软件的系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏本软件系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称；<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.1.5用户通过非爱趣焙公司开发、授权或认可的第三方兼容软件、系统登入或使用本软件及服务，或制作、发布、传播上述工具；<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.1.6未经爱趣焙书面同意，用户对软件及其中信息擅自实施包括但不限于下列行为：使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版，建立镜像站点、擅自借助本软件发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等；<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.1.7利用本软件发表、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容；<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.1.8利用本软件批量发表、传送、传播广告信息及垃圾信息；<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.1.9其他以任何不合法的方式、为任何不合法的目的、或任何与本协议许可使用不一致的方式使用本软件和爱趣焙提供的其他服务。<br />
        &nbsp;&nbsp;&nbsp;&nbsp; 4.2信息发布规范<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.2.1您可使用本软件发表属于您原创或您有权发表的观点看法、数据、文字、信息、用户名、图片、个人信息、音频、视频文件、链接等信息内容。您必须保证，您拥有您所上传信息内容的知识产权或已获得合法授权，您使用本软件及服务的任何行为未侵犯任何第三方之合法权益。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.2.2您在使用本软件时需遵守当地法律法规要求。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.2.3您在使用本软件时不得利用本软件从事以下行为，包括但不限于：<br />
        &nbsp;&nbsp;&nbsp;&nbsp;    4.2.3.1制作、复制、发布、传播、储存违反当地法律法规的内容；<br />  
        &nbsp;&nbsp;&nbsp;&nbsp;    4.2.3.2发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；<br />
        &nbsp;&nbsp;&nbsp;&nbsp;    4.2.3.3虚构事实、隐瞒真相以误导、欺骗他人；<br />
        &nbsp;&nbsp;&nbsp;&nbsp;    4.2.3.4发表、传说、传播广告信息及垃圾信息；<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.2.4未经爱趣焙许可，您不得在本软件中进行任何诸如发布广告、销售商品的商业行为。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;  4.3您理解并同意<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.3.1爱趣焙会对用户是否涉嫌违反上述使用规范做出认定，并根据认定结果中止、终止对您的使用许可或采取其他依本约定可采取的限制措施；<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.3.2对于用户使用许可软件时发布的涉嫌违法或涉嫌侵犯他人合法权利或违反本协议的信息，爱趣焙会直接删除；<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.3.3对于用户违反上述使用规范的行为对第三方造成损害的，您需要以自己的名字独立承担法律责任，并应确保爱趣焙免于因此产生损失或增加费用；<br />
        &nbsp;&nbsp;&nbsp;&nbsp;   4.3.4若用户违反有关法律规定或协议约定，使爱趣焙遭受损失，或遭到第三方的索赔，或收到行政管理机关的处罚，用户应当赔偿爱趣焙因此造成的损失和（或）发生的费用，包括合理的律师费、调查费用。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;五.服务风险及免责声明<br />
        &nbsp;&nbsp;&nbsp;&nbsp;  5.1用户必须自行配备移动终端设备上网，自行负担个人移动终端设备上网或第三方收取的通讯费、信息费等有关费用。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;  5.2用户因第三方如通讯线路故障、技术问题、网络、移动终端设备故障、系统不稳定性及其他各种不可抗力原因而遭受的一切损失，爱趣焙及合作单位不承担责任。<br />      
        &nbsp;&nbsp;&nbsp;&nbsp;  5.4因用户使用本软件或要求爱趣焙提供特定服务时，本软件可能会调用第三方系统或第三方软件支持用户的使用或访问，使用或访问的结果由该第三方提供给，爱趣焙不保证通过第三方系统或第三方软件支持实现的结果的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，爱趣焙不承担任何责任。  <br />   
        &nbsp;&nbsp;&nbsp;&nbsp;  5.5爱趣焙特别提请用户注意，爱趣焙为了保障公司业务发展和调整的自主权，爱趣焙公司拥有随时修改或中断服务而不需通知用户的权力，爱趣焙行使修改或中断服务的权力不需对用户或任何第三方负责。    <br />
        &nbsp;&nbsp;&nbsp;&nbsp;  5.6除法律法规有明确规定外，我们将尽最大努力确保软件及其所涉及的技术及信息安全、有效、准确、可靠，但受限于现有技术，用户理解爱趣焙不能对此进行担保。 <br />
        &nbsp;&nbsp;&nbsp;&nbsp;  5.7由于用户因下述任一情况所引起或与此有关的人身伤害或附带的、间接的经济损害赔偿，包括但不限于利润损失、资料损失、业务中断的损害赔偿或其他商业损害赔偿或损失，需由用户自行承担：  <br /> 
        &nbsp;&nbsp;&nbsp;&nbsp;    5.7.1使用或未能使用许可的软件；  <br />
        &nbsp;&nbsp;&nbsp;&nbsp;    5.7.2第三方未经许可的使用软件或更改用户的数据；   <br />    
        &nbsp;&nbsp;&nbsp;&nbsp;    5.7.3用户使用软件进行的行为产生的费用及损失；<br />     
        &nbsp;&nbsp;&nbsp;&nbsp;    5.7.4用户对软件的误解； <br />     
        &nbsp;&nbsp;&nbsp;&nbsp;    5.7.5因非爱趣焙的原因引起的与软件有关的其他损失  <br />
        &nbsp;&nbsp;&nbsp;&nbsp;   5.8用户与其他使用软件的用户之间通过软件进行的行为，因您受误导或欺骗而导致或可能导致的任何人身或经济上的伤害或损失，均由过错方依法承担所有责任。  <br /> 
        &nbsp;&nbsp;&nbsp;&nbsp;六.知识产权声明 <br />
        &nbsp;&nbsp;&nbsp;&nbsp;   6.1爱趣焙是本软件的知识产权权利人，本软件 一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受您所在当地法律法规和相应的国际条约保护，爱趣焙享有上述知识产权。  <br />  
        &nbsp;&nbsp;&nbsp;&nbsp;   6.2未经爱趣焙书面同意，用户不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权，爱趣焙保留追究上述行为法律责任的权利。  <br />
        &nbsp;&nbsp;&nbsp;&nbsp;隐私政策<br />
        &nbsp;&nbsp;&nbsp;&nbsp;我们向您承诺<br />
        &nbsp;&nbsp;&nbsp;&nbsp;本隐私政策规定了爱趣焙及关联公司（下文简称“我们”）如何收集、使用、披露、处理和保护您在使用我们的产品和服务时通过爱趣焙APP提供给我们的信息。若我们要求您提供某些信息，以便在使用爱趣焙产品和服务时验证您的身份，我们将严格遵守本隐私政策和/或我们的用户条款与条件来使用这些信息。 <br />   
        &nbsp;&nbsp;&nbsp;&nbsp;本隐私政策在制定时充分考虑到您的需求；您全面了解我们的个人资料收集和使用惯例，而且确信自己最终能控制提供给爱趣焙的所有个人信息，这一点至关重要。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;在这项隐私政策中，“个人信息”所指通过有关特定个人的信息，或者与爱趣焙能够访问的其他关于该人的信息相结合后，能够直接或间接识别该人的所有数据。此类个人信息包括但不限于您提供或上传的信息和设备信息。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;通过使用爱趣焙产品和服务或其他符合使用法律的操作，即表示您已阅读并接受本隐私和政策中所述之所有条款，包括我们定期做出的任何更改。遵守使用法律，包括本地数据保护法律，我们将会对于特定类别的个人数据的处理征求您的明确同意。另外，我们承诺遵照适用法律（包括您所在地的数据保护法律）来保护您的个人信息的隐私、机密和安全。同时我们承诺确保我们的全体员工和代理商履行这些义务。<br />   
        &nbsp;&nbsp;&nbsp;&nbsp;最后，我们所希望的就是为我们的用户带来最好的体验。
`
}
